import { NgClass } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Popover, PopoverModule } from 'primeng/popover';
import { IconComponent } from '../../components/icon/icon.component';
import { ModalAction } from './modal-action.interface';

@Component({
  selector: 'l-modal-actions',
  standalone: true,
  templateUrl: './modal-actions.component.html',
  imports: [NgClass, RouterLink, PopoverModule, IconComponent],
})
export class ModalActionsComponent {

  @Input({ required: true })
  public actions: ModalAction[] = [];

  @ViewChild('panel')
  private readonly panel!: Popover;

  public toggle(event: Event): void {
    this.panel.toggle(event);
  }

  public hide(): void {
    this.panel.hide();
  }

  public handleAction(action: ModalAction, event: Event): void {
    event.stopPropagation();

    if (action.disabled) {
      return;
    }

    action.callback?.();
    this.hide();
  }
}
